import React from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const FaqItem = (props) => {
  const faq = props;
  return (
    <>
      <Accordion className="my-2">
        <AccordionSummary
          className="py-1 rounded"
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          style={{
            background: 'rgb(44,81,115)',
            color: 'white',
          }}
        >
          <Typography className="question">
            Q.&ensp;
            {faq.question}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className="m-3">
            <div
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: faq.answer }}
            />
          </Typography>
        </AccordionDetails>
      </Accordion>
    </>
  );
};

export default FaqItem;
